(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
  // Bundle picker CTA: add, then open the cart drawer. It used to jump straight
  // to /checkout, which skipped the cart (and its upsells) entirely.
  window.bundleAddToCart = function(variantId, quantity, sellingPlanId, properties) {
    if (!variantId) { alert('Product not configured. Please contact support.'); return; }

    const sellingPlan = sellingPlanId ? parseInt(sellingPlanId, 10) : null;

    // Line properties arrive as a JSON string from the picker's hidden input.
    let lineProperties = null;
    if (properties) {
      try {
        lineProperties = typeof properties === 'string' ? JSON.parse(properties) : properties;
      } catch (error) {
        lineProperties = null;
      }
    }

    if (typeof window.addToCartAndOpenSidecart === 'function') {
      return window.addToCartAndOpenSidecart(parseInt(variantId, 10), quantity || 1, lineProperties, sellingPlan);
    }

    // Cart bridge missing (drawer app unavailable): fall back to the cart page.
    const payload = { id: parseInt(variantId, 10), quantity: quantity || 1 };
    if (sellingPlan) payload.selling_plan = sellingPlan;
    if (lineProperties) payload.properties = lineProperties;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      if (res.ok) {
        window.location.href = '/cart';
      } else {
        return res.json().then(function(data) {
          alert(data.description || 'Could not add to cart. Please try again.');
        });
      }
    })
    .catch(() => { alert('Error adding item to cart. Please try again.'); });
  };

  (() => {
    function initBundlePicker(container) {
      // The dynamic picker owns its own state (cards, purchase options, selling
      // plans) and writes the hidden inputs itself. Running the Kaching sync on
      // top of it would re-check its radios and fight the default selection.
      if (container.querySelector('[data-bp-dynamic]')) return;

      const blockId = container.id;
      const imageCards = [...container.querySelectorAll('.bundle-img-card')];

      function highlightImage(idx) {
        imageCards.forEach((card, i) => {
          card.classList.toggle('border-purple', i === idx);
          card.classList.toggle('border-gray-border', i !== idx);
        });
      }

      function syncFromRadios() {
        const radios = [...container.querySelectorAll('input[type="radio"]')];
        const idx = radios.findIndex((r) => r.checked);
        if (idx >= 0) highlightImage(idx);

        // Also update hidden inputs if present (fallback/non-Kaching mode)
        const activeRow = container.querySelector('.bundle-option.border-purple');
        const formInput = document.getElementById(`product-variant-id-${blockId}`);
        if (formInput && activeRow?.dataset.variantId) formInput.value = activeRow.dataset.variantId;
        const qtyInput = document.getElementById(`product-quantity-${blockId}`);
        if (qtyInput && activeRow?.dataset.quantity) qtyInput.value = activeRow.dataset.quantity;
      }

      // Kaching (and fallback) radio change
      container.addEventListener('change', (e) => {
        if (e.target.type === 'radio') syncFromRadios();
      });

      // Clicking an image card → click the nth radio (works for both Kaching & fallback)
      imageCards.forEach((card, i) => {
        card.addEventListener('click', () => {
          const radios = [...container.querySelectorAll('input[type="radio"]')];
          if (radios[i]) {
            radios[i].click();
          } else {
            highlightImage(i);
          }
        });
      });

      // Fallback: our own .bundle-option rows
      container.querySelectorAll('.bundle-option').forEach((row) => {
        row.addEventListener('click', () => {
          container.querySelectorAll('.bundle-option').forEach((r) => {
            const active = r === row;
            r.classList.toggle('border-purple', active);
            r.classList.toggle('bg-gray-light', active);
            r.classList.toggle('border-gray-border', !active);
          });
          const idx = [...container.querySelectorAll('.bundle-option')].indexOf(row);
          highlightImage(idx);
          const formInput = document.getElementById(`product-variant-id-${blockId}`);
          if (formInput && row.dataset.variantId) formInput.value = row.dataset.variantId;
          const qtyInput = document.getElementById(`product-quantity-${blockId}`);
          if (qtyInput && row.dataset.quantity) qtyInput.value = row.dataset.quantity;
        });
      });

      // MutationObserver: Kaching renders async and updates radio state via DOM
      const observer = new MutationObserver(() => syncFromRadios());
      observer.observe(container, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['checked', 'class'],
      });

      // Force-check the default radio on init so it renders as selected
      const defaultRadio = container.querySelector('input[type="radio"][checked], input[type="radio"]:checked');
      if (defaultRadio) {
        defaultRadio.checked = true;
        syncFromRadios();
      }
    }

    document.querySelectorAll('[id^="bp-"]').forEach(initBundlePicker);
  })();

  (() => {
    document.querySelectorAll('[data-article-copy-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        const url = button.getAttribute('data-share-url');

        if (navigator.share) {
          try {
            await navigator.share({ url });
            return;
          } catch (error) {
            if (error.name === 'AbortError') return;
          }
        }

        if (navigator.clipboard && url) {
          await navigator.clipboard.writeText(url);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Initialize all carousels
    const initCarousel = (carouselType) => {
      const carousel = document.querySelector(`[data-carousel="bestsellers-${carouselType}"]`);
      if (!carousel) return;

      const track = carousel.querySelector('[data-carousel-track]');
      const slides = carousel.querySelectorAll('.bestsellers-carousel__slide');
      const indicators = carousel.querySelectorAll(
        `[data-carousel-indicators="${carouselType}"] [data-carousel-indicator]`
      );
      const prevButton = carousel.querySelector(`[data-carousel-prev="${carouselType}"]`);
      const nextButton = carousel.querySelector(`[data-carousel-next="${carouselType}"]`);

      if (!track || slides.length === 0) return;

      let currentSlide = 0;
      const totalSlides = slides.length;

      // Get products per slide based on carousel type
      const getProductsPerSlide = () => {
        switch (carouselType) {
          case 'desktop':
            return 4;
          case 'tablet':
            return 2;
          case 'mobile':
            return 1;
          default:
            return 1;
        }
      };

      const productsPerSlide = getProductsPerSlide();

      // Get total number of products by counting articles in slides
      const getTotalProducts = () => {
        let totalProducts = 0;
        slides.forEach((slide) => {
          totalProducts += slide.querySelectorAll('article').length;
        });
        return totalProducts;
      };

      const totalProducts = getTotalProducts();

      // Update carousel position and indicators
      const updateCarousel = () => {
        const translateX = -currentSlide * 100;
        track.style.transform = `translateX(${translateX}%)`;

        // Update indicators
        indicators.forEach((indicator, index) => {
          if (index === currentSlide) {
            indicator.classList.remove('bg-gray/30');
            indicator.classList.add('bg-purple');
          } else {
            indicator.classList.remove('bg-purple');
            indicator.classList.add('bg-gray/30');
          }
        });
      };

      // Go to specific slide
      const goToSlide = (slideIndex) => {
        currentSlide = Math.max(0, Math.min(slideIndex, totalSlides - 1));
        updateCarousel();
      };

      // Calculate the maximum slide index that ensures the last slide shows full products
      const getMaxSlideIndex = () => {
        const productsInLastSlide = totalProducts % productsPerSlide;
        if (productsInLastSlide === 0) {
          // Perfect fit - use all slides
          return totalSlides - 1;
        } else {
          // Adjust to ensure last visible slide has full products
          const slidesToSkip = Math.ceil((productsPerSlide - productsInLastSlide) / productsPerSlide);
          return Math.max(0, totalSlides - 1 - slidesToSkip);
        }
      };

      const maxSlideIndex = getMaxSlideIndex();

      // Smart navigation that ensures last slide is always full
      const nextSlide = () => {
        if (totalSlides <= 1) {
          return; // No navigation needed for single slide
        }

        if (currentSlide < maxSlideIndex) {
          currentSlide++;
        } else {
          // On the last allowed slide, jump to show the end with full products
          const productsInLastSlide = totalProducts % productsPerSlide;
          if (productsInLastSlide > 0 && currentSlide < totalSlides - 1) {
            // Jump to position that shows the last products in a full slide
            currentSlide = totalSlides - 1;
          } else {
            // Loop back to beginning
            currentSlide = 0;
          }
        }
        updateCarousel();
      };

      const prevSlide = () => {
        if (totalSlides <= 1) {
          return; // No navigation needed for single slide
        }

        if (currentSlide > 0) {
          // Check if we're at the last slide showing partial products
          const productsInLastSlide = totalProducts % productsPerSlide;
          if (currentSlide === totalSlides - 1 && productsInLastSlide > 0) {
            // Jump back to the max normal slide
            currentSlide = maxSlideIndex;
          } else {
            currentSlide--;
          }
        } else {
          // Loop to the optimal end position
          const productsInLastSlide = totalProducts % productsPerSlide;
          if (productsInLastSlide > 0) {
            currentSlide = totalSlides - 1; // Show the last slide with remaining products
          } else {
            currentSlide = totalSlides - 1; // Perfect fit
          }
        }
        updateCarousel();
      };

      // Add click handlers to indicators
      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          goToSlide(index);
        });
      });

      // Handle touch/swipe gestures
      let startX = 0;
      let isDragging = false;

      const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      };

      const handleTouchMove = (e) => {
        if (!isDragging) return;

        const currentX = e.touches[0].clientX;
        const diffX = startX - currentX;

        // Prevent vertical scrolling if horizontal swipe is detected
        if (Math.abs(diffX) > 30) {
          e.preventDefault();
        }
      };

      const handleTouchEnd = (e) => {
        if (!isDragging) return;

        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        const threshold = 50; // Minimum swipe distance

        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            nextSlide(); // Swipe left - go to next
          } else {
            prevSlide(); // Swipe right - go to previous
          }
        }

        isDragging = false;
      };

      // Add touch event listeners
      carousel.addEventListener('touchstart', handleTouchStart, { passive: false });
      carousel.addEventListener('touchmove', handleTouchMove, { passive: false });
      carousel.addEventListener('touchend', handleTouchEnd);

      // Button event listeners
      if (prevButton) {
        prevButton.addEventListener('click', prevSlide);
      }

      if (nextButton) {
        nextButton.addEventListener('click', nextSlide);
      }

      // Initialize position
      updateCarousel();
    };

    // Initialize all carousel types
    initCarousel('desktop');
    initCarousel('tablet');
    initCarousel('mobile');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-section [data-accordion]');

    faqItems.forEach((item) => {
      const toggle = item.querySelector('[data-accordion-toggle]');
      const panel = item.querySelector('[data-accordion-panel]');

      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          const isOpen = item.hasAttribute('data-open');

          if (isOpen) {
            // Close current item
            item.removeAttribute('data-open');
            toggle.setAttribute('aria-expanded', 'false');
            panel.style.maxHeight = '0';
          } else {
            // Close all other items first
            faqItems.forEach((otherItem) => {
              if (otherItem !== item && otherItem.hasAttribute('data-open')) {
                const otherToggle = otherItem.querySelector('[data-accordion-toggle]');
                const otherPanel = otherItem.querySelector('[data-accordion-panel]');

                otherItem.removeAttribute('data-open');
                otherToggle.setAttribute('aria-expanded', 'false');
                otherPanel.style.maxHeight = '0';
              }
            });

            // Open current item
            item.setAttribute('data-open', '');
            toggle.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const accordion = document.querySelector('[data-footer-accordion]');
    if (!accordion) return;

    accordion.querySelectorAll('[data-footer-section]').forEach((section) => {
      const toggle = section.querySelector('[data-footer-toggle]');
      const content = section.querySelector('[data-footer-content]');
      const indicator = section.querySelector('[data-footer-indicator]');
      if (!toggle || !content || !indicator) return;

      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        content.hidden = isExpanded;
        indicator.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header="main"]');
    if (!header) return;

    // Desktop Search Functionality
    const searchContainer = header.querySelector('[data-search-container]');
    const toggleButton = header.querySelector('[data-search-toggle]');
    const searchInput = header.querySelector('[data-search-input]');
    const submitButton = header.querySelector('[data-search-submit]');

    if (searchContainer && toggleButton && searchInput && submitButton) {
      const openSearch = () => {
        searchContainer.classList.add('header-search--open');
        submitButton.classList.remove('hidden');
        toggleButton.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          searchInput.focus();
        });
      };

      const closeSearch = () => {
        searchContainer.classList.remove('header-search--open');
        submitButton.classList.add('hidden');
        toggleButton.setAttribute('aria-expanded', 'false');
        searchInput.value = '';
      };

      toggleButton.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = searchContainer.classList.contains('header-search--open');
        if (isOpen) {
          if (searchInput.value.trim() === '') {
            closeSearch();
          } else {
            searchContainer.closest('form').submit();
          }
        } else {
          openSearch();
        }
      });

      searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeSearch();
        }
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          closeSearch();
        }
      });
    }

    // Mobile Menu Functionality
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuPanel = document.getElementById('mobile-menu-panel');

    if (mobileMenuOverlay && mobileMenuPanel) {
      window.openMobileMenu = () => {
        mobileMenuOverlay.classList.remove('opacity-0', 'pointer-events-none');
        mobileMenuOverlay.classList.add('opacity-100');
        mobileMenuPanel.classList.remove('translate-x-full');
        document.body.style.overflow = 'hidden';
      };

      window.closeMobileMenu = () => {
        mobileMenuOverlay.classList.add('opacity-0', 'pointer-events-none');
        mobileMenuOverlay.classList.remove('opacity-100');
        mobileMenuPanel.classList.add('translate-x-full');
        document.body.style.overflow = '';
      };

      // Close mobile menu on escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !mobileMenuPanel.classList.contains('translate-x-full')) {
          closeMobileMenu();
        }
      });

      // Update mobile cart count when cart changes
      const updateMobileCartCount = () => {
        const desktopCartCount = document.querySelector('[data-cart-count]');
        const mobileCartCount = document.querySelector('[data-cart-count-mobile]');
        if (desktopCartCount && mobileCartCount) {
          mobileCartCount.textContent = desktopCartCount.textContent;
        }
      };

      // Listen for cart updates
      document.addEventListener('DOMContentLoaded', updateMobileCartCount);

      // Update mobile cart count when sidecart updates
      const originalUpdateCartCount = window.updateCartCount;
      if (originalUpdateCartCount) {
        window.updateCartCount = function (count) {
          originalUpdateCartCount(count);
          updateMobileCartCount();
        };
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-feature-accordion-root]');
    if (!root) return;

    const items = root.querySelectorAll('[data-feature-item]');
    if (!items.length) return;

    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const setExpanded = (item, expanded, isMobile) => {
      const content = item.querySelector('[data-feature-content]');
      const indicator = item.querySelector('[data-feature-indicator]');
      const toggle = item.querySelector('[data-feature-toggle]');

      if (!content || !toggle) return;

      if (isMobile) {
        content.classList.toggle('hidden', !expanded);
      } else {
        content.classList.remove('hidden');
      }

      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      indicator?.classList.toggle('rotate-180', expanded);
      item.dataset.featureOpen = expanded ? 'true' : 'false';
    };

    const applyMobileState = () => {
      items.forEach((item, index) => {
        const shouldOpen = item.hasAttribute('data-feature-default') || index === 0;
        setExpanded(item, shouldOpen, true);
      });
    };

    const applyDesktopState = () => {
      items.forEach((item) => {
        setExpanded(item, true, false);
      });
    };

    const handleToggle = (currentItem) => (event) => {
      if (!mediaQuery.matches) return;
      event.preventDefault();

      const isCurrentlyExpanded = currentItem.dataset.featureOpen === 'true';
      
      if (isCurrentlyExpanded) {
        // If clicking on already expanded item, close it
        setExpanded(currentItem, false, true);
      } else {
        // If clicking on collapsed item, close all others and open this one
        items.forEach((item) => {
          setExpanded(item, item === currentItem, true);
        });
      }
    };

    items.forEach((item) => {
      const toggle = item.querySelector('[data-feature-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', handleToggle(item));
    });

    const handleModeChange = (event) => {
      if (event.matches) {
        applyMobileState();
      } else {
        applyDesktopState();
      }
    };

    mediaQuery.addEventListener('change', handleModeChange);
    handleModeChange(mediaQuery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('product-review-form');
    if (!form) return;

    const ratingInput = form.querySelector('[data-rating-input]');
    const ratingButtons = ratingInput?.querySelectorAll('[data-rating-value]');
    const ratingHiddenInput = form.querySelector('input[name="rating"]');
    let selectedRating = 0;

    // Store SVG content for stars
    const starFullSVG = `<svg class="h-full w-full" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19z"/></svg>`;
    const starEmptySVG = `<svg class="h-full w-full" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" xmlns="http://www.w3.org/2000/svg"><path d="M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19z"/></svg>`;

    // Handle star rating selection
    ratingButtons?.forEach((button) => {
      const value = parseInt(button.getAttribute('data-rating-value'), 10);
      
      button.addEventListener('click', () => {
        selectedRating = value;
        ratingHiddenInput.value = value;
        
        // Update visual state
        ratingButtons.forEach((btn) => {
          const btnValue = parseInt(btn.getAttribute('data-rating-value'), 10);
          const starIcon = btn.querySelector('.rating-star-icon');
          
          if (btnValue <= value) {
            starIcon.innerHTML = starFullSVG;
            starIcon.classList.remove('text-purple/30');
            starIcon.classList.add('text-purple');
            starIcon.setAttribute('data-star-state', 'full');
          } else {
            starIcon.innerHTML = starEmptySVG;
            starIcon.classList.remove('text-purple');
            starIcon.classList.add('text-purple/30');
            starIcon.setAttribute('data-star-state', 'empty');
          }
        });
      });
    });

    // Handle form submission
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const productId = form.getAttribute('data-product-id');
      const productHandle = form.getAttribute('data-product-handle');
      
      const reviewData = {
        product_id: productId,
        product_handle: productHandle,
        rating: parseInt(formData.get('rating'), 10),
        name: formData.get('name'),
        email: formData.get('email'),
        comment: formData.get('comment') || ''
      };

      // TODO: Replace this URL with your backend endpoint or app proxy URL
      // Example: '/apps/reviews/submit' or 'https://your-backend.com/api/reviews'
      const endpoint = form.getAttribute('data-endpoint') || '/apps/reviews/submit';
      
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(reviewData)
        });

        const result = await response.json();
        const messageDiv = document.getElementById('review-form-message');
        const successMessage = form.getAttribute('data-success-message');
        const errorMessage = form.getAttribute('data-error-message');
        
        if (response.ok) {
          messageDiv.textContent = successMessage;
          messageDiv.classList.remove('hidden', 'bg-red-50', 'text-red-800');
          messageDiv.classList.add('bg-green-50', 'text-green-800');
          form.reset();
          selectedRating = 0;
          ratingHiddenInput.value = '';
          
          // Reset star display
          ratingButtons?.forEach((btn) => {
            const starIcon = btn.querySelector('.rating-star-icon');
            starIcon.innerHTML = starEmptySVG;
            starIcon.classList.remove('text-purple');
            starIcon.classList.add('text-purple/30');
            starIcon.setAttribute('data-star-state', 'empty');
          });
          
          // Reload page after 2 seconds to show updated rating
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          messageDiv.textContent = result.error || errorMessage;
          messageDiv.classList.remove('hidden', 'bg-green-50', 'text-green-800');
          messageDiv.classList.add('bg-red-50', 'text-red-800');
        }
      } catch (error) {
        const messageDiv = document.getElementById('review-form-message');
        const errorMessage = form.getAttribute('data-error-message');
        messageDiv.textContent = errorMessage;
        messageDiv.classList.remove('hidden', 'bg-green-50', 'text-green-800');
        messageDiv.classList.add('bg-red-50', 'text-red-800');
        console.error('Review submission error:', error);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-special-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-item');

    function isMobile() {
      return window.innerWidth < 640; // sm breakpoint
    }

    function initFAQ() {
      // Close all FAQs first
      faqItems.forEach((item) => {
        toggleFAQ(item, false);
      });

      // Open first item(s) based on screen size
      if (isMobile()) {
        // On mobile, open only the first FAQ overall
        if (faqItems[0]) {
          toggleFAQ(faqItems[0], true);
        }
      } else {
        // On desktop/tablet, open first item in each column
        const leftColumn = document.querySelectorAll('[data-column="left"] .faq-item');
        const rightColumn = document.querySelectorAll('[data-column="right"] .faq-item');

        if (leftColumn[0]) {
          toggleFAQ(leftColumn[0], true);
        }
        if (rightColumn[0]) {
          toggleFAQ(rightColumn[0], true);
        }
      }
    }

    // Initialize on load
    initFAQ();

    // Add click handlers
    faqItems.forEach((item) => {
      const button = item.querySelector('[data-faq-toggle]');
      button.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // If opening this FAQ, close others
        if (!isActive) {
          if (isMobile()) {
            // On mobile, close ALL other FAQs (only one open at a time)
            faqItems.forEach((faq) => {
              if (faq !== item) {
                toggleFAQ(faq, false);
              }
            });
          } else {
            // On desktop/tablet, close others in the same column only
            const column = item.closest('[data-column]');
            const columnFaqs = column.querySelectorAll('.faq-item.active');
            columnFaqs.forEach((faq) => {
              if (faq !== item) {
                toggleFAQ(faq, false);
              }
            });
          }
        }

        // Toggle current FAQ
        toggleFAQ(item, !isActive);
      });
    });

    function toggleFAQ(item, open) {
      const answer = item.querySelector('.faq-answer');
      const content = answer.querySelector('div');

      if (open) {
        item.classList.add('active');
        answer.style.maxHeight = content.scrollHeight + 'px';
      } else {
        item.classList.remove('active');
        answer.style.maxHeight = '0';
      }
    }

    // Reinitialize on resize
    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initFAQ, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-special-how-to-use"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Desktop/Tablet Horizontal Timeline
    const container = document.querySelector('.timeline-circles-container');
    const circles = document.querySelectorAll('.timeline-circle');
    const labels = document.querySelectorAll('.timeline-label');
    
    // Mobile Vertical Timeline
    const mobileItems = document.querySelectorAll('.timeline-mobile-item');
    const mobileCircles = document.querySelectorAll('.timeline-circle-mobile');
    const mobileLabels = document.querySelectorAll('.timeline-label-mobile');
    
    let isAnimating = false;
    let currentlyActive = false;
    
    function checkScroll() {
      if (isAnimating) return;
      
      // Check which timeline is visible
      const isMobile = window.innerWidth < 768;
      
      if (isMobile && mobileItems.length > 0) {
        // Mobile timeline animation
        const firstItem = mobileItems[0];
        const rect = firstItem.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Check if section is visible
        const isVisible = rect.top >= 0 && rect.bottom <= windowHeight;
        
        if (isVisible && !currentlyActive) {
          // Animate forward
          isAnimating = true;
          currentlyActive = true;
          
          mobileCircles.forEach((circle, index) => {
            setTimeout(() => {
              circle.classList.add('timeline-circle-active');
              if (mobileLabels[index]) {
                mobileLabels[index].classList.add('timeline-label-active');
              }
              
              if (index === mobileCircles.length - 1) {
                setTimeout(() => {
                  isAnimating = false;
                }, 700);
              }
            }, index * 300);
          });
        } else if (!isVisible && currentlyActive) {
          // Animate backward (reverse)
          isAnimating = true;
          currentlyActive = false;
          
          const reversedCircles = Array.from(mobileCircles).reverse();
          const reversedLabels = Array.from(mobileLabels).reverse();
          
          reversedCircles.forEach((circle, index) => {
            setTimeout(() => {
              circle.classList.remove('timeline-circle-active');
              if (reversedLabels[index]) {
                reversedLabels[index].classList.remove('timeline-label-active');
              }
              
              if (index === reversedCircles.length - 1) {
                setTimeout(() => {
                  isAnimating = false;
                }, 700);
              }
            }, index * 300);
          });
        }
      } else if (container) {
        // Desktop/Tablet timeline animation
        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        const isVisible = rect.top >= 0 && rect.bottom <= windowHeight - (windowHeight * 0.2);
        
        if (isVisible && !currentlyActive) {
          isAnimating = true;
          currentlyActive = true;
          
          circles.forEach((circle, index) => {
            setTimeout(() => {
              circle.classList.add('timeline-circle-active');
              if (labels[index]) {
                labels[index].classList.add('timeline-label-active');
              }
              
              if (index === circles.length - 1) {
                setTimeout(() => {
                  isAnimating = false;
                }, 700);
              }
            }, index * 300);
          });
        } else if (!isVisible && currentlyActive) {
          isAnimating = true;
          currentlyActive = false;
          
          const reversedCircles = Array.from(circles).reverse();
          const reversedLabels = Array.from(labels).reverse();
          
          reversedCircles.forEach((circle, index) => {
            setTimeout(() => {
              circle.classList.remove('timeline-circle-active');
              if (reversedLabels[index]) {
                reversedLabels[index].classList.remove('timeline-label-active');
              }
              
              if (index === reversedCircles.length - 1) {
                setTimeout(() => {
                  isAnimating = false;
                }, 700);
              }
            }, index * 300);
          });
        }
      }
    }
    
    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', function() {
      // Reset animation state on resize
      currentlyActive = false;
      isAnimating = false;
      checkScroll();
    });
    checkScroll(); // Check on load
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-special-journey"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const journeyItemsDesktop = document.querySelectorAll('.journey-item');
    const journeyItemsMobile = document.querySelectorAll('.journey-item-mobile');
    
    function checkScroll() {
      const windowHeight = window.innerHeight;
      const triggerPoint = windowHeight * 0.6; // 60% from bottom = 40% from top
      
      // Desktop animation
      if (window.innerWidth >= 1024) {
        journeyItemsDesktop.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const itemTop = rect.top;
          
          // Check if item has reached the trigger point (scrolling down) or left it (scrolling up)
          if (itemTop <= triggerPoint) {
            // Activate current item
            if (!item.classList.contains('active')) {
              item.classList.add('active');
            }
            
            // Complete the previous item's bottom line
            if (index > 0) {
              const prevItem = journeyItemsDesktop[index - 1];
              const prevLineBottom = prevItem.querySelector('.journey-line-bottom');
              if (prevLineBottom && !prevLineBottom.classList.contains('completed')) {
                prevLineBottom.classList.add('completed');
              }
            }
          } else {
            // Deactivate item when scrolling up past trigger point
            if (item.classList.contains('active')) {
              item.classList.remove('active');
            }
            
            // Revert the previous item's bottom line to gradient
            if (index > 0) {
              const prevItem = journeyItemsDesktop[index - 1];
              const prevLineBottom = prevItem.querySelector('.journey-line-bottom');
              if (prevLineBottom && prevLineBottom.classList.contains('completed')) {
                prevLineBottom.classList.remove('completed');
              }
            }
          }
        });
      }
      // Mobile/Tablet animation
      else {
        journeyItemsMobile.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const itemTop = rect.top;
          
          // Check if item has reached the trigger point (scrolling down) or left it (scrolling up)
          if (itemTop <= triggerPoint) {
            // Activate current item
            if (!item.classList.contains('active')) {
              item.classList.add('active');
            }
            
            // Complete the previous item's bottom line
            if (index > 0) {
              const prevItem = journeyItemsMobile[index - 1];
              const prevLineBottom = prevItem.querySelector('.journey-line-bottom');
              if (prevLineBottom && !prevLineBottom.classList.contains('completed')) {
                prevLineBottom.classList.add('completed');
              }
            }
          } else {
            // Deactivate item when scrolling up past trigger point
            if (item.classList.contains('active')) {
              item.classList.remove('active');
            }
            
            // Revert the previous item's bottom line to gradient
            if (index > 0) {
              const prevItem = journeyItemsMobile[index - 1];
              const prevLineBottom = prevItem.querySelector('.journey-line-bottom');
              if (prevLineBottom && prevLineBottom.classList.contains('completed')) {
                prevLineBottom.classList.remove('completed');
              }
            }
          }
        });
      }
    }
    
    // Check on scroll
    window.addEventListener('scroll', checkScroll);
    
    // Initial check
    checkScroll();
    
    // Reinitialize on resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        checkScroll();
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const timerSection = document.querySelector('[data-timer-section]');
    if (!timerSection) return;

    const slides = timerSection.querySelectorAll('[data-timer-slide]');
    let currentSlide = 0;

    // Initialize countdowns for all slides (desktop and mobile)
    const allSlides = timerSection.querySelectorAll('[data-timer-slide], [data-timer-slide-mobile]');
    allSlides.forEach((slide, index) => {
      const endDate = slide.dataset.endDate;
      const endTime = slide.dataset.endTime;

      if (endDate && endTime) {
        const endDateTime = new Date(`${endDate}T${endTime}`);
        const countdown = slide.querySelector('[data-countdown]');
        const countdownMobile = slide.querySelector('[data-countdown-mobile]');

        if (countdown) {
          updateCountdown(countdown, endDateTime);
          setInterval(() => {
            updateCountdown(countdown, endDateTime);
          }, 1000);
        }

        if (countdownMobile) {
          updateCountdown(countdownMobile, endDateTime);
          setInterval(() => {
            updateCountdown(countdownMobile, endDateTime);
          }, 1000);
        }
      }
    });

    // Auto-rotate slides if more than one
    const mobileSlides = timerSection.querySelectorAll('[data-timer-slide-mobile]');
    
    if (slides.length > 1) {
      setInterval(() => {
        // Hide current desktop slide
        slides[currentSlide].style.transition = 'transform 0.8s ease-out, opacity 0.8s ease-out';
        slides[currentSlide].style.transform = 'translateX(-100%)';
        slides[currentSlide].style.opacity = '0';

        // Hide current mobile slide
        if (mobileSlides[currentSlide]) {
          mobileSlides[currentSlide].style.transition = 'transform 0.8s ease-out, opacity 0.8s ease-out';
          mobileSlides[currentSlide].style.transform = 'translateX(-100%)';
          mobileSlides[currentSlide].style.opacity = '0';
        }

        setTimeout(() => {
          // Reset desktop slide
          slides[currentSlide].style.display = 'none';
          slides[currentSlide].style.transform = 'translateX(0)';
          slides[currentSlide].style.opacity = '1';
          slides[currentSlide].style.transition = '';

          // Reset mobile slide
          if (mobileSlides[currentSlide]) {
            mobileSlides[currentSlide].style.display = 'none';
            mobileSlides[currentSlide].style.transform = 'translateX(0)';
            mobileSlides[currentSlide].style.opacity = '1';
            mobileSlides[currentSlide].style.transition = '';
          }

          // Show next slide
          currentSlide = (currentSlide + 1) % slides.length;
          
          // Show next desktop slide
          slides[currentSlide].style.display = 'flex';
          slides[currentSlide].style.transform = 'translateX(100%)';
          slides[currentSlide].style.opacity = '0';

          // Show next mobile slide
          if (mobileSlides[currentSlide]) {
            mobileSlides[currentSlide].style.display = 'flex';
            mobileSlides[currentSlide].style.transform = 'translateX(100%)';
            mobileSlides[currentSlide].style.opacity = '0';
          }

          // Animate in from right
          setTimeout(() => {
            // Animate desktop slide
            slides[currentSlide].style.transition = 'transform 0.8s ease-out, opacity 0.8s ease-out';
            slides[currentSlide].style.transform = 'translateX(0)';
            slides[currentSlide].style.opacity = '1';

            // Animate mobile slide
            if (mobileSlides[currentSlide]) {
              mobileSlides[currentSlide].style.transition = 'transform 0.8s ease-out, opacity 0.8s ease-out';
              mobileSlides[currentSlide].style.transform = 'translateX(0)';
              mobileSlides[currentSlide].style.opacity = '1';
            }

            // Reset transition after animation
            setTimeout(() => {
              slides[currentSlide].style.transition = '';
              if (mobileSlides[currentSlide]) {
                mobileSlides[currentSlide].style.transition = '';
              }
            }, 50);
          }, 50);
        }, 800);
      }, 12000); // Change every 12 seconds
    }

    function updateCountdown(countdown, endDate) {
      const now = new Date().getTime();
      const distance = endDate.getTime() - now;

      const updateDigits = (tensSelector, onesSelector, value) => {
        const tensEl = countdown.querySelector(tensSelector);
        const onesEl = countdown.querySelector(onesSelector);
        if (!tensEl || !onesEl) return;
        tensEl.textContent = value[0];
        onesEl.textContent = value[1];
        tensEl.classList.toggle('is-zero', value[0] === '0');
        onesEl.classList.toggle('is-zero', value[1] === '0');
      };

      if (distance < 0) {
        updateDigits('[data-days-tens]', '[data-days-ones]', '00');
        updateDigits('[data-hours-tens]', '[data-hours-ones]', '00');
        updateDigits('[data-minutes-tens]', '[data-minutes-ones]', '00');
        updateDigits('[data-seconds-tens]', '[data-seconds-ones]', '00');
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const daysStr = days.toString().padStart(2, '0');
      const hoursStr = hours.toString().padStart(2, '0');
      const minutesStr = minutes.toString().padStart(2, '0');
      const secondsStr = seconds.toString().padStart(2, '0');

      updateDigits('[data-days-tens]', '[data-days-ones]', daysStr);
      updateDigits('[data-hours-tens]', '[data-hours-ones]', hoursStr);
      updateDigits('[data-minutes-tens]', '[data-minutes-ones]', minutesStr);
      updateDigits('[data-seconds-tens]', '[data-seconds-ones]', secondsStr);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
